// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { UserDO, RolePermissionDO } from 'wdna-components';

import store from '../../store/configure';
import { routes } from '../../routes/dashboard';
import { config } from '../../config/config';

const formRef: React.RefObject<HTMLFormElement> = React.createRef<HTMLFormElement>();

/**
 * Function to submit wiki formulary
 *
 * @param e form event with the submit action
 */
function goWiki(e: React.FormEvent): void {
  e.preventDefault();
  formRef.current?.submit();
}

/**
 * Returns the menu entries of the client dashboards
 *
 * @param user user configuration to generate entries
 * @returns react node with the menu entries
 */
function getUserDashboards(user: UserDO): React.ReactNode[] | null {
  const { type, role } = user;
  if (type === 'cli') {
    const permissions: RolePermissionDO[] = role?.role_permissions || [];
    if (permissions) {
      const allowed: any[] = permissions.map((p: RolePermissionDO): string => { return p?.permission?.label || ''; });
      const result: React.ReactNode[] = routes.map(
        (r: any): React.ReactNode => (
          allowed.includes(r.code)
          && (
            <li>
              <a href={`#${r.path}`} className="padding-10 padding-top-0 padding-bottom-0">
                <i className="wdna-ico-icon-dashboard" />
                {r.name}
              </a>
            </li>
          )
        )
      );

      return result;
    }
  }

  return null;
}

/**
 * Component to generate the user menu
 *
 * @returns react node with the user menu element
 */
export default function UserMenu(): JSX.Element {
  const user: UserDO = _.get(store.getState(), ['user', 'user']);
  const userIsClient: boolean = (user && user.type === 'cli');

  const dashboards: React.ReactNode[] | null = getUserDashboards(user);
  const { wiki } = config;

  return (
    <ul id="mobile-profile-img" className="header-dropdown-list hidden-xs padding-5">
      <li className="">
        <a href="#/" className="dropdown-toggle no-margin userdropdown" data-toggle="dropdown">
          <i className="wdna-ico-icon-user" />
        </a>
        <ul className="dropdown-menu pull-right">
          <div>
            {dashboards}
            {userIsClient && (
              <li>
                <a href="#/sensors/sensors_graphs" className="padding-10 padding-top-0 padding-bottom-0">
                  <i className="wdna-ico-icon-bars-lines" />
                  Sensors Graphs
                </a>
              </li>
            )}
            {userIsClient && (
              <li>
                <a href="#/sensors/reports" className="padding-10 padding-top-0 padding-bottom-0">
                  <i className="wdna-ico-icon-bars-lines" />
                  Reports
                </a>
              </li>
            )}
            <li>
              <a href="#/settings/user" className="padding-10 padding-top-0 padding-bottom-0">
                <i className="wdna-ico-icon-config" />
                Your settings
              </a>
            </li>
            <li className="divider" />
          </div>
          <li>
            <a href="#/logout" className="padding-10 padding-top-0 padding-bottom-0">
              <i className="wdna-ico-icon-logout" />
              Logout
            </a>
          </li>
        </ul>
      </li>
      <form ref={formRef} method="post" encType="multipart/form-data" target="_blank" action={wiki?.url.toString()}>
        <input type="hidden" name="id" value="start" />
        <input type="hidden" name="do" value="login" />
        <input type="hidden" name="u" value={wiki?.user} />
        <input type="hidden" name="p" value={wiki?.pass} />
      </form>
    </ul>
  );
}
